import { makeAutoObservable } from "mobx";
import { exportDRTBDashboard, getDashboardSummary, getDetecionTreatment, getDetecionTreatmentByYears } from "./DashboardService";
import "react-toastify/dist/ReactToastify.css";
import { omit } from 'lodash'
import LocalConst from "app/LocalConstants";
import { getFirstOfDay, getLastOfDay } from "app/common/CommonFunctions";
import { toast } from "react-toastify";
import i18n from "i18n";

const dataDefaultFormSearch = {
    fromDate: null,
    toDate: null,
    source: 2,
    typeTime: 4,
    administrativeUnitId: null,
    region: null,
    province: null,
    organization: null,
    organizationId: null,
    fromYear: new Date().getFullYear(),
    toYear: new Date().getFullYear()
}

const dataDefaultSummary = {
    hivPercent: 0,
    hivQuantity: 0,
    womenPercent: 0,
    womenQuantity: 0,
    childPercent: 0,
    childQuantity: 0,
    detectedCasePercent: 0,
    detectedCaseQuantity: 0,
    treatmentedCasePercent: 0,
    treatmentedCaseQuantity: 0,
    treatmentedSuccessQuantity: 0,
    treatmentedSuccessPercent: 0,
    detectedTargetQuantity: 0,
    beingTreatmentedQuantity: 0
}

export default class DashboardStore {

    loadingInitial = false;
    listDetecionTreatment = [];
    listOrg = [];
    searchOjb = {...dataDefaultFormSearch};
    dataSummary = {...dataDefaultSummary};
    currentAdministrativeUnit = null

    constructor() {
        makeAutoObservable(this);
    }

    setLoadingInitial = (state) => {
        this.loadingInitial = state;
    };

    loadDetecionTreatment = () => {
        const newSearchObj = omit(this.searchOjb, ['organization', 'province', 'region']);
        
        this.loadDataDashboardSummary(newSearchObj);
        if (newSearchObj?.typeTime == LocalConst.ListChooseDashboard[1].value && 
            newSearchObj?.source == LocalConst.ReportSourceSearch[1]?.value) {
            getDetecionTreatmentByYears({...newSearchObj, patientType: LocalConst.PATIENT_TYPE_DRUG_RESISTANT_TB}).then(({data}) => {
                let newData = [...data]
                if (newData?.length > 0 && !newData[0]?.organizationId && newSearchObj?.administrativeUnitId) {
                    this.currentAdministrativeUnit = newData[0]
                    newData.shift();
                } else {
                    this.currentAdministrativeUnit = null;
                }
                this.listDetecionTreatment = newData.filter(item => !item?.organizationId);
                this.listOrg = newData.filter(item => !!item?.organizationId);
            })
        } else {
            const newObj = {...newSearchObj}
            if (newObj?.typeTime == LocalConst.ListChooseDashboard[1]?.value) {
                newObj.fromDate = getFirstOfDay(new Date(newObj.fromYear, 0, 1));
                newObj.toDate = getLastOfDay(new Date(newObj.toYear, 11, 31));
                newObj.fromYear = undefined;
                newObj.toYear = undefined;
                newObj.typeTime = LocalConst.ListChooseDashboard[0]?.value
            }
            getDetecionTreatment(newObj).then(({ data }) => {
                let newData = data?.administrativeUnits
                if (newData?.length > 0 && Boolean(newData[0]?.level)) {
                    this.currentAdministrativeUnit = newData[0]
                    newData.shift();
                } else {
                    this.currentAdministrativeUnit = null;
                }
                this.listDetecionTreatment = newData;
                this.listOrg = data?.organizations;
            });
        }
        
    }

    setSearchOjb = (searchOjb) => {
        this.searchOjb = {...searchOjb};
        this.loadDetecionTreatment();
    }

    loadDataDashboardSummary = (obj) => {
        getDashboardSummary(obj).then((response) => {
            this.dataSummary = {
                ...this.dataSummary,
                ...response.data
            };
        })
    }

    resetDashboardStore = () => {
        this.loadingInitial = false;
        this.listDetecionTreatment = [];
        this.listOrg = [];
        this.searchOjb = {...dataDefaultFormSearch};
        this.dataSummary = {...dataDefaultSummary};
        this.currentAdministrativeUnit = null
    }

    handleExportExcel = (values) => {
        const newValues = {
            ...values,
            organizationId: values?.organization?.id,
            administrativeUnitId: values?.province?.id || values?.region?.id,
            regionAdminiId: values?.region?.id,
            provinceId: values?.province?.id
        }
        const newSearchObj = omit(newValues, ['organization', 'province', 'region']);
        exportDRTBDashboard(newSearchObj).then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TONGQUAN_LKT_" + new Date().getTime() + ".xlsx");
            document.body.appendChild(link);
        link.click();
        }).catch(error => {
            console.log(error);
            toast.warning(i18n.t("toast.error"));
        })
    }
}
